import { ForgotPasswordForm } from "../../organisms/form/ForgotPasswordForm";
import { CardTemplate } from "../../templates/CardTemplate";
import { useForgotPassword } from "./hook";

export const ForgotPasswordPage: React.FC = () => {
  const { email, handleForgotPassword, handleCancel } = useForgotPassword();

  return (
    <CardTemplate title="パスワード再設定">
      <ForgotPasswordForm
        email={email}
        handleSubmit={handleForgotPassword}
        handleCancel={handleCancel}
      />
    </CardTemplate>
  );
};
